export enum OrganizationsPaths {
  Create = 'create',
  Users = 'users',
  Settings = 'settings',
  PlansAndBilling = 'plans-and-billing',
  InviteUsers = 'invite',
  AcceptInvite = 'accept-invite',
}

export enum OrganizationsParams {
  OrganizationId = 'organizationId',
  UserId = 'userId',
  UserRoleFilter = 'role',
  UserStatusFilter = 'status',
}
